// import store from '@/store'

// This is for browser notification (do not be confuse with our internal notification)
export const notify = (message = '') => {
  // Remove Web Notification 1st, IE 11 seems to have some problems

  // const options = {
  //   body: message,
  //   icon: '/static/img/notification.png'
  // }
  // if (Notification) {
  //   new Notification(store.state.app.projectTitle, options) // eslint-disable-line no-new
  // }
}
